import {chevronDown, chevronUp} from '@sail/icons/react/Icon';
import {HeaderButton, Placement} from './HeaderButton';
import {useWidgetControls, useWidgetVisibility} from '../useWidget';
import {useAnalytics} from '../../AnalyticsProvider';
import {toggleMinimizeButtonMessages} from './ToggleMinimizeButtonMessages';

type Props = {
  disabled?: boolean;
};

export function ToggleMinimizeButton({disabled = false}: Props) {
  const {visibility} = useWidgetVisibility();
  const {toggle} = useWidgetControls();
  const analytics = useAnalytics();

  let label;
  let icon;
  let placement: Placement;

  if (visibility === 'open') {
    label = toggleMinimizeButtonMessages.minimize;
    icon = chevronDown;
    placement = 'bottom left';
  } else {
    label = toggleMinimizeButtonMessages.open;
    icon = chevronUp;
    placement = 'left';
  }

  return (
    <HeaderButton
      testId="conversations-widget-header-toggle-button"
      icon={icon}
      label={label}
      onPress={() => {
        analytics.action('toggle_minimize_button_clicked');
        toggle();
      }}
      tooltipPlacement={placement}
      disabled={disabled}
    />
  );
}
